module.exports = __webpack_public_path__ + "static/media/1b.0c4b5691.jpg";